<form #form="ngForm" class="campanha-representante-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Representantes
            </h6>
            <p class="form-text text-muted">
                Representantes que podem utilizar esta campanha
            </p>

            <div class="card-header-warning" *ngIf="canEdit">
                <div class="card-header-warning-icon">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="card-header-warning-text">
                    <span>Ao adicionar um ou mais representantes, esta campanha poderá ser utilizada somente por estes</span>
                    <span>Não adicione nenhum representante para que todos possam utilizá-la</span>
                </div>                     
            </div>
        </div> 
        <div class="table-responsive campanha-representante">
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th class="col-options" *ngIf="canEdit"></th>
                        <th class="col-representante">Representante</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities; let i = index">
                        <td class="col-options" *ngIf="canEdit">
                            <a (click)="delete(i)">
                                <i class="far fa-trash-alt" aria-hidden="true"></i>
                            </a>
                        </td>
                        <td class="col-representante">
                            <ng-template [ngIf]="canEdit">
                                <sgt-typeahead-representante [(ngModel)]="entity.representante" name="representante_{{i}}" id="representante_{{i}}"
                                    #representante="ngModel" [ngControl]="representante" #typeaheadRepresentante [situacao]="1" required="required"
                                    [dropup]="i >= 4" (typeaheadChange)="onChangeRepresentante(entity, $event)">
                                </sgt-typeahead-representante>
                                <sgt-form-control-error
                                    *ngIf="representante.errors && representante.errors.required && representante.dirty"
                                    msgError="O representante é obrigatório">
                                </sgt-form-control-error>
                            </ng-template>
                            <ng-template [ngIf]="!canEdit">
                                {{entity.representante.pessoa?.nome | representanteNome: entity.representante.pessoa?.nomeFantasia:entity.representante.pessoa?.codigoIntegracaoErp}}
                            </ng-template>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="entities?.length === 0" class="no-record">
                    <tr>
                        <td class="text-center" colspan="2">
                            <i class='fas fa-info' aria-hidden='true'></i> Campanha disponível para todos os representantes
                        </td>
                    </tr>
                </tbody>
                <tfoot class="table-footer" *ngIf="canEdit">
                    <tr>
                        <td colspan="2">
                            <button type="button" class="btn btn-primary btn-sm mr-2" (click)="insert()">
                                <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Representante
                            </button>
                            <button type="button" class="btn btn-light btn-sm mr-2" (click)="openPopulaCidadeModal()">
                                <i class="fas fa-bolt" aria-hidden="true"></i> Adicionar Vários Representantes
                            </button>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div> 
    </div>
</form>

<!-- Modal para popular os representantes -->
<sgt-campanha-representante-popula-modal
    #campanhaRepresentantePopulaModal
    [entities]="entities">
</sgt-campanha-representante-popula-modal>
